export const certificateDetailEntries = (applicationData) => {
  if (!applicationData || typeof applicationData !== 'object' || Array.isArray(applicationData)) return [];

  const topLevelKeys = new Set(Object.keys(applicationData));

  return Object.entries(applicationData).flatMap(([key, value]) => {
    if (key !== 'custom_fields') return [[key, value]];
    if (!value || typeof value !== 'object' || Array.isArray(value)) return [];

    return Object.entries(value).filter(([customKey]) => !topLevelKeys.has(customKey));
  });
};

export const certificateDetailValue = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const orderedCertificateDetails = (applicationData, configuredSections = []) => {
  const entries = certificateDetailEntries(applicationData);
  const values = new Map(entries);
  const ordered = [];
  const used = new Set();
  const sections = Array.isArray(configuredSections) ? configuredSections : [];

  sections.forEach(section => {
    (section?.fields || []).forEach(field => {
      if (!field?.key || used.has(field.key) || !values.has(field.key)) return;
      ordered.push({ key: field.key, label: field.label || field.key, value: values.get(field.key) });
      used.add(field.key);
    });
  });

  entries.forEach(([key, value]) => {
    if (!used.has(key)) ordered.push({ key, label: key.replace(/_/g, ' ').replace(/\b\w/g, character => character.toUpperCase()), value });
  });

  return ordered;
};
